import React from "react";

const MXNIcon: React.FC<{ size?: number }> = ({ size = 51 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 980 560"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0" y="0" width="326.67" height="560" fill="#006847" />

      <rect x="326.67" y="0" width="326.67" height="560" fill="#ffffff" />

      <rect x="653.34" y="0" width="326.66" height="560" fill="#ce1126" />

      <g transform="translate(490, 280)">
        <g>
          <ellipse cx="0" cy="20" rx="25" ry="35" fill="#8f4620" />

          <circle cx="0" cy="-15" r="15" fill="#8f4620" />

          <path d="M-5,-25 L5,-25 L0,-15 Z" fill="#f8c83c" />

          <ellipse
            cx="-20"
            cy="0"
            rx="15"
            ry="25"
            fill="#8f4620"
            transform="rotate(-30 -20 0)"
          />
          <ellipse
            cx="20"
            cy="0"
            rx="15"
            ry="25"
            fill="#8f4620"
            transform="rotate(30 20 0)"
          />

          <path d="M-10,45 L-5,55 L-15,50 Z" fill="#f8c83c" />
          <path d="M10,45 L5,55 L15,50 Z" fill="#f8c83c" />
        </g>

        <g>
          <rect x="-8" y="30" width="16" height="40" fill="#04534e" />

          <rect
            x="-25"
            y="35"
            width="12"
            height="30"
            fill="#04534e"
            transform="rotate(-20 -25 35)"
          />
          <rect
            x="13"
            y="35"
            width="12"
            height="30"
            fill="#04534e"
            transform="rotate(20 13 35)"
          />

          <circle cx="-15" cy="40" r="1" fill="#202020" />
          <circle cx="-10" cy="45" r="1" fill="#202020" />
          <circle cx="10" cy="45" r="1" fill="#202020" />
          <circle cx="15" cy="40" r="1" fill="#202020" />
        </g>

        <g>
          <path
            d="M-20,60 Q-10,50 0,55 Q10,60 20,50"
            stroke="#8f4620"
            strokeWidth="3"
            fill="none"
          />
          <circle cx="-15" cy="58" r="2" fill="#8f4620" />
          <circle cx="15" cy="52" r="2" fill="#8f4620" />
        </g>
      </g>
    </svg>
  );
};

export default MXNIcon;
